<template>
  <div class="statement-collapse">
    <b-collapse
      :id="`collapse-${statement.type}-${statement.id}`"
      class="w-100"
      :visible="opened"
    >
      <b-row>
        <b-col :cols="linkedInvoiceCols">
          <strong>{{ $t(setoffText) }}</strong>
          <div
            class="d-flex justify-content-between"
            :key="i"
            v-for="(invoice, i) in setOffData"
          >
            <div class="d-flex-grow">
              <b-link
                :to="{ name: 'invoicesSingle', params: { id: invoice.id } }"
                target="_blank"
                exact
                >{{ invoice.reference }}</b-link
              >
              <div class="buyer-names">{{ invoice.buyer }}</div>
            </div>
            <div class="d-flex-grow text-right">
              {{ invoice.value | currency(currency) }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: [
    'setOffData',
    'opened',
    'statement',
    'setoffText',
    'linkedInvoiceCols'
  ]
}
</script>
